// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2pTvE","actionsCol":"EnrolledClinics_actionsCol__-RPHV"};